export default "__VITE_ASSET__Chi$VtmD__"